export const CREATE_DOCUMENT_ACTION = '[Document Action] Create Document';
export const CONFIRMED_CREATE_DOCUMENT_ACTION = '[Document Action] Confirmed Create Document';
export const CREATE_DOCUMENT_ERROR_ACTION='[Document Action] Create Document Error';
export const GET_DOCUMENTS = '[Document Action] Get Documents';
export const CONFIRMED_GET_DOCUMENTS = '[Document Action] Confirmed Get Documents';
export const LOADING_DOCUMENTS = '[Document Action] Loading for Documents';
export const EDIT_DOCUMENT_ACTION = '[Document Action] Edit Document';
export const CONFIRMED_EDIT_DOCUMENT_ACTION = '[Document Action] Confirmed Edit Document';
export const DELETE_DOCUMENT_ACTION = '[Document Action] Delete Document';
export const CONFIRMED_DELETE_DOCUMENT_ACTION = '[Document Action] Confirmed Delete Document';
export const DOCUMENT_ERROR_ACTION = '[Document Action] Error';
export const CLEAR_DOCUMENT_ERROR = '[Document Action] Clear Error';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';



